import {makeStyles} from '@material-ui/core'


export const useStyles = makeStyles((theme) =>({

    name:{
        letterSpacing: '4px',
        animation: `$infiniteLoop 250ms ${theme.transitions.easing.sharp} infinite`,
        [theme.breakpoints.down('xs')]:{
            marginTop: '20px',
            textAlign: 'center'
        }
    },
    "@keyframes infiniteLoop":{
        "0%":{
            transform: 'translate(-1.5%, 1.5%)'
        },
        "100%":{
            transform: 'translate(0)'
        }
    }
}))